import PropertyComposite from "./PropertyComposite";

export default function SectorSpace({sector}) {
    return (
        <>
            <PropertyComposite property={sector.getProperty('padding')} units={["px"]}/>
            <PropertyComposite property={sector.getProperty('margin')} units={["px"]}/>
        </>
    );
}